import React from "react";
import PropTypes from "prop-types";
import {ReactComponent as UserIcon} from './icons/User.svg';
import {ReactComponent as LockIcon} from './icons/Lock.svg';
import {ReactComponent as LogOutIcon} from './icons/LogOut.svg';
import {ReactComponent as HomeIcon} from './icons/Home.svg';
import {ReactComponent as HomeBoldIcon} from './icons/HomeBold.svg';
import {ReactComponent as ClipboardIcon} from './icons/Clipboard.svg';
import {ReactComponent as ClipboardBoldIcon} from './icons/ClipboardBold.svg';
import {ReactComponent as FilterIcon} from './icons/Filter.svg';
import {ReactComponent as InfoIcon} from './icons/Info.svg';
import {ReactComponent as AwardIcon} from './icons/Award.svg';
import {ReactComponent as AwardBoldIcon} from './icons/AwardBold.svg';
import {ReactComponent as ClockIcon} from './icons/Clock.svg';
import {ReactComponent as CheckCircleIcon} from './icons/CheckCircle.svg';
import {ReactComponent as FlagIcon} from './icons/Flag.svg';
import {ReactComponent as UsersIcon} from './icons/Users.svg';
import {ReactComponent as FileTextIcon} from './icons/FileText.svg';
import {ReactComponent as MessageCircleIcon} from './icons/MessageCircle.svg';
import {ReactComponent as CalendarIcon} from './icons/Calendar.svg';
import {ReactComponent as PauseCircleIcon} from './icons/PauseCircle.svg';
import {ReactComponent as ExternalLinkIcon} from './icons/ExternalLink.svg';
import {ReactComponent as StudentsIcon} from './icons/Students.svg';
import {ReactComponent as ClinicIcon} from './icons/Clinic.svg';
import {ReactComponent as ClinicFullIcon} from './icons/ClinicFull.svg';
import {ReactComponent as ArrowUpIcon} from './icons/ArrowUp.svg';
import {ReactComponent as TrashIcon} from './icons/Trash.svg';
import {ReactComponent as CheckIcon} from './icons/Check.svg';
import {ReactComponent as UploadIcon} from './icons/Upload.svg';
import {ReactComponent as PlusIcon} from './icons/Plus.svg';
import {ReactComponent as ArrowUpRightIcon} from './icons/ArrowUpRight.svg';
import {ReactComponent as SaveIcon} from './icons/Save.svg';
import {ReactComponent as SettingsIcon} from './icons/Settings.svg';
import {ReactComponent as FilterSliderIcon} from './icons/FilterSlider.svg';
import {ReactComponent as ChevronIcon} from './icons/Chevron.svg';
import {ReactComponent as XCircleIcon} from './icons/XCircle.svg';
import {ReactComponent as EditIcon} from './icons/Edit.svg';
import {ReactComponent as CopyIcon} from './icons/Copy.svg';
import {ReactComponent as GraduationIcon} from './icons/Graduation.svg';
import {ReactComponent as GraduationUnionIcon} from './icons/GraduationUnion.svg';
import {ReactComponent as EditHistoryIcon} from './icons/EditHistory.svg';
import {ReactComponent as DownloadIcon} from './icons/Download.svg';

const Icon = ({ name, ...props }) => {
  switch(name) {
    case 'user': return <UserIcon {...props} />;
    case 'lock': return <LockIcon {...props} />;
    case 'logOut': return <LogOutIcon {...props} />;
    case 'home': return <HomeIcon {...props} />;
    case 'home-bold': return <HomeBoldIcon {...props} />;
    case 'clipboard': return <ClipboardIcon {...props} />;
    case 'clipboard-bold': return <ClipboardBoldIcon {...props} />;
    case 'filter': return <FilterIcon {...props} />;
    case 'info': return <InfoIcon {...props} />;
    case 'award': return <AwardIcon {...props} />;
    case 'award-bold': return <AwardBoldIcon {...props} />;
    case 'clock': return <ClockIcon {...props} />;
    case 'check-circle': return <CheckCircleIcon {...props} />;
    case 'flag': return <FlagIcon {...props} />;
    case 'users': return <UsersIcon {...props} />;
    case 'file-text': return <FileTextIcon {...props} />;
    case 'message-circle': return <MessageCircleIcon {...props} />;
    case 'calendar': return <CalendarIcon {...props} />;
    case 'pause-circle': return <PauseCircleIcon {...props} />;
    case 'external-link': return <ExternalLinkIcon {...props} />;
    case 'students': return <StudentsIcon {...props} />;
    case 'clinic': return <ClinicIcon {...props} />;
    case 'clinic-full': return <ClinicFullIcon {...props} />;
    case 'arrow-up': return <ArrowUpIcon {...props} />;
    case 'trash': return <TrashIcon {...props} />;
    case 'check': return <CheckIcon {...props} />;
    case 'upload': return <UploadIcon {...props} />;
    case 'plus': return <PlusIcon {...props} />;
    case 'arrow-up-right': return <ArrowUpRightIcon {...props} />;
    case 'save': return <SaveIcon {...props} />;
    case 'settings': return <SettingsIcon {...props} />;
    case 'filter-slider': return <FilterSliderIcon {...props} />;
    case 'chevron': return <ChevronIcon {...props} />;
    case 'x-circle': return <XCircleIcon {...props} />;
    case 'edit': return <EditIcon {...props} />;
    case 'copy': return <CopyIcon {...props} />;
    case 'graduation': return <GraduationIcon {...props} />;
    case 'graduation-union': return <GraduationUnionIcon {...props} />;
    case 'edit-history': return <EditHistoryIcon {...props} />;
    case 'download': return <DownloadIcon {...props} />;
    default: return <span>Icon not found</span>
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired
};

export default Icon;